import { useConfiguratorContext } from "@studio3dx/legacy-use-configurator/react";
import { ConfiguratorSectionProps } from "../RenderCustomComponent";
import { CheckboxWithText } from "../CheckboxWithText";
import { useStudio } from "@/hooks/useStudio";
import { useEffect, useState } from "react";
import { Slider } from "@/components/ui/slider";
import { OptionItem } from "../display/OptionItem";

export function RoofControl(props: ConfiguratorSectionProps) {
  const configurator = useConfiguratorContext();
  const studio = useStudio();
  const [selectedStripes, setSelectedStripes] = useState<boolean>(false);

  const [stripeOffset, setStripeOffset] = useState<number>(0.25);
  const [stripeFrequency, setStripeFrequency] = useState<number>(3);
  const [stripeThickness, setStripeThickness] = useState<number>(0.5);

  const materialName = "soft-top";

  

  useEffect(() => {
    // console.log("StripesInput values changed:", {
    //   selectedStripes,
    //   stripeOffset,
    //   stripeFrequency,
    //   stripeThickness,
    // });

    if (selectedStripes) {
      studio.viewer.setMaterial(materialName, {
        uniforms: {
          stripeOffset: stripeOffset,
          stripeFrequency: stripeFrequency,
          stripeThickness: stripeThickness,
        },
      });
    }
  }, [selectedStripes, stripeOffset, stripeFrequency, stripeThickness]);

  const { section } = props;
  const { options } = section;

  const handleChange = (value: boolean) => {
    console.log("StripesInput handleChange:", { value });
    setSelectedStripes(value);

    if (value) {
      studio.viewer.setMaterial(materialName, {
        onBeforeCompile: {
          uniforms: {
            stripeFrequency: { value: 3 },
            stripeThickness: { value: 0.5 },
            stripeOffset: { value: 0.25 },
          },

          vertexReplacements: [
            {
              search: "#include <common>",
              replace: `
                          #include <common>
                          varying vec2 vUv;
                        `,
            },
            {
              search: "#include <uv_vertex>",
              replace: `
                          #include <uv_vertex>
                          vUv = uv;
                        `,
            },
          ],
          fragmentReplacements: [
            {
              search: "#include <common>",
              replace: `
                          #include <common>
                          varying vec2 vUv;
                          uniform float stripeFrequency;
                          uniform float stripeThickness;
                          uniform float stripeOffset;
                        `,
            },
            {
              search: "#include <map_fragment>",
              replace: `
                          #include <map_fragment>
                          // Procedural stripes along U (horizontal) using dynamic frequency and thickness
                          float stripe = step(stripeThickness, fract(vUv.x * stripeFrequency + stripeOffset));
                          diffuseColor.rgb = mix(diffuseColor.rgb, vec3(1.0), stripe);
                        `,
            },
          ],
        },
      });
    } else {
      studio.viewer.setMaterial(materialName, {
        onBeforeCompile: {
          vertexReplacements: [],
          fragmentReplacements: [],
          uniforms: {},
        },
      });
    }
  };

 

  const stripeOptionId = "ROOF_STRIPES";

  const defaultOptions = options.filter(
    (option) => option.id !== stripeOptionId
  );

  const stripeOption = options.find((option) =>
    option.id === stripeOptionId
  );

  useEffect(() => {
    if (studio.loaded) {
      handleChange(configurator.isOptionSelected(stripeOptionId));
    }
  }, [studio.loaded, configurator.isOptionSelected(stripeOptionId)]);

  return (
    <div className="flex flex-col gap-3">
      {defaultOptions.map((option) => (
        <OptionItem
          key={option.id}
          option={option}
          section={section}
          isSelected={configurator.isOptionSelected(option.id)}
          canSelect={configurator.canSelectOption(section.id, option.id)}
          onToggle={() => configurator.toggleOption(section.id, option.id)}
        />
      ))}

      {stripeOption && (
        <OptionItem
          key={stripeOption.id}
          option={stripeOption}
          section={section}
          isSelected={configurator.isOptionSelected(stripeOption.id)}
          canSelect={configurator.canSelectOption(section.id, stripeOption.id)}
          onToggle={(value) => {
            configurator.toggleOption(section.id, stripeOption.id);
            handleChange(value);
          }}
        />
      )}

      {/* {selectedStripes && (
        <>
          <label>Stripe Offset</label>
          <Slider
            id="stripe-offset"
            title="Stripe Offset"
            value={[stripeOffset]}
            onValueChange={(value) => setStripeOffset(value[0])}
            min={0}
            max={1}
            step={0.01}
          />

          <label>Stripe Frequency</label>
          <Slider
            id="stripe-frequency"
            title="Stripe Frequency"
            value={[stripeFrequency]}
            onValueChange={(value) => setStripeFrequency(value[0])}
            min={1}
            max={10}
            step={1}
          />

          <label>Stripe Thickness</label>
          <Slider
            id="stripe-thickness"
            title="Stripe Thickness"
            value={[stripeThickness]}
            onValueChange={(value) => setStripeThickness(value[0])}
            min={0}
            max={1}
            step={0.01}
          />
        </>
      )} */}
    </div>
  );
}
